import type { SlotContents } from '@amplience/content-types/typings/s-pdp-layout';
import { createGlobalAmplienceComponent } from '@storefront/lib-global/globalComponents/globalAmplienceComponents.utils';
import type { HandlebarTemplateProps } from '@storefront/lib-global/globalComponents/handlebarTemplate';
import { renderAmplienceSlotComponents } from '@storefront/lib-global/utils/amplienceUtils';
import { createPDPAmplienceComponent } from './pdpAmplienceComponents.utils';

export function renderBelowAddToBagContent({
  belowATBContent,
  handlebarComponents,
  locale,
}: {
  belowATBContent: SlotContents['belowATBContent'];
  handlebarComponents: HandlebarTemplateProps[] | null;
  locale?: string;
}) {
  return renderAmplienceSlotComponents(
    belowATBContent as [],
    { ...createGlobalAmplienceComponent(belowATBContent as []), ...createPDPAmplienceComponent(belowATBContent as []) },
    handlebarComponents,
    locale,
  );
}
